import EvidenceApi from '../../../api/evidence.js';
import EvidenceDefaultModel from '../../models/EvidenceDefaultModel.js';

const state = {
  isCalculating: false,
  hasCalculatingError: false,
  valueToMove: 0,
  valueToMoveSource: null,
  valueToMoveIdent: null,
  evidence: EvidenceDefaultModel(),
};

const getters = {};

const actions = {
  fetchEvidences({ commit, state }, { url = '', sortType, config = {} } = {}) {
    return new Promise((resolve, reject) => {
      EvidenceApi.KPIR.fetchEvidences(url, sortType, config).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  fetchSales({ commit, state }, { url = '', sortType, config = {} } = {}) {
    return new Promise((resolve, reject) => {
      EvidenceApi.KPIR.fetchSales(url, sortType, config).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  fetchPurchases({ commit, state }, { url = '', sortType, config = {} } = {}) {
    return new Promise((resolve, reject) => {
      EvidenceApi.KPIR.fetchPurchases(url, sortType, config).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  calculateEvidence({ commit, state }, payload) {
    commit('setIsCalculating', true);

    return new Promise((resolve, reject) => {
      let abortController = new AbortController();
      hubAbortControllerProviderInstance
        .abort(`evidence__calculate`)
        .set(`evidence__calculate`, abortController);

      EvidenceApi.RYCZALT
        .calculate({ ...state.evidence, ...payload }, {
            signal: abortController.signal,
          },
        )
        .then(response => {
          hubAbortControllerProviderInstance
            .set(`evidence__calculate`, null);
          commit('setIsCalculating', false);
          commit('hasCalculatingError', false);
          commit('setEvidence', {
            ...state.evidence,
            ...response.data,
          });
          resolve(response);
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            throw error;
          }
          resolve();
        })
        .catch(error => {
          if (error.response && error.response.status >= 500) {
            window.hubApp.$vs.notify({
              title: 'Błąd',
              text: 'Nie udało się pobrać wyliczeń.',
              color: 'danger',
              position: 'bottom-right',
            });
          }
          throw error;
        })
        .catch(error => {
          commit('setIsCalculating', false);
          commit('hasCalculatingError', true);
          hubAbortControllerProviderInstance
            .set(`evidence__calculate`, null);
          reject(error);
        });
    });
  },
  destroyEvidence({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      EvidenceApi.RYCZALT.destroy(id).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};

const mutations = {
  setEvidence(state, evidence) {
    state.evidence = evidence;
  },
  setIsCalculating(state, value) {
    state.isCalculating = !!value;
  },
  hasCalculatingError(state, value) {
    state.hasCalculatingError = !!value;
  },
  setValueToMoveSource(state, { source = null, ident = null }) {
    state.valueToMoveSource = source;
    state.valueToMoveIdent = ident;
  },
  setValueToMove(state, value) {
    state.valueToMove = value;
  },
  clearValueToMove(state) {
    state.valueToMove = 0;
    state.valueToMoveSource = null;
    state.valueToMoveIdent = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
